// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_BUSCAR_AUTO_ENTREGA,
} from './constants';

export function buscarAutoEntrega(bool) {
  return {
    type: PRESUPUESTADOR_BUSCAR_AUTO_ENTREGA,
    data: bool
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_BUSCAR_AUTO_ENTREGA:
      return {
        ...state,
        buscarAutoEntrega: action.data
      };

    default:
      return state;
  }
}
